import { useState, useEffect } from 'react'
import { supabase } from './supabase'
import { Session } from '@supabase/supabase-js'

export function useAuth() {
  const [session, setSession] = useState<Session | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Get initial session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      setLoading(false)
    })

    // Listen for auth changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
      setLoading(false)
    })

    return () => subscription.unsubscribe()
  }, [])

  const signInWithGoogle = async () => {
    // Determine the redirect URL based on the environment
    // alert('signInWithGoogle called')
    console.log('Debug info:', {
      NODE_ENV: process.env.NODE_ENV,
      windowLocation: window.location.href,
      windowOrigin: window.location.origin,
      isProduction: process.env.NODE_ENV === 'production'
    });
    
    // const redirectTo = process.env.NODE_ENV === 'production' 
    //   ? 'https://litewrite.vercel.app'
    //   : 'http://localhost:3000'
    
    const redirectTo = process.env.REACT_APP_AUTH_REDIRECT_URL || window.location.origin
    console.log('Using redirect URL:', redirectTo);

    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo
      }
    })
    if (error) {
      console.error('Error signing in with Google:', error.message)
    }
  }

  const signOut = async () => {
    const { error } = await supabase.auth.signOut()
    try {
      // Clear device-local resume pointer on logout
      localStorage.removeItem('lw:lastNote')
    } catch {}
    if (error) {
      console.error('Error signing out:', error.message)
    }
  }

  return {
    session,
    loading,
    signInWithGoogle,
    signOut
  }
} 